export enum BillProcessingStatus {
  Provisional = 'Provisional',
  ReadyForProcessing = 'Ready for Processing',
}
